import React from "react";
// import image1 from "../../images/aboutslush.png";
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function ReasonstoinvestPage() {
	return (
		<div className={styles.ReasonstoinvestPage}>
			<Helmet>
				<title>Wet Willie's Franchise | Reasons to Invest</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>REASONS TO INVEST</h1>
			</div>
			<div className={styles.articleContainer}>
				<article>
					<section className={styles.section2}>
						<h1>BEFORE YOU INVEST</h1>
						<ul>
							<li>
								<span>•</span>
								As an entrepreneur you will be working for
								yourself
							</li>
							<li>
								<span>•</span>
								You are investing in a proven operating system
							</li>
							<li>
								<span>•</span>
								You can know exactly what you're buying before
								you buy
							</li>
							<li>
								<span>•</span>You'll have a positive Corporate
								Image
							</li>
							<li>
								<span>•</span>You'll have Immediate Brand
								Awareness
							</li>
							<li>
								<span>•</span>
								You'll potentially win the admiration of others
							</li>
							<li>
								<span>•</span>Risk Avoidance
							</li>
						</ul>

						<h1>GETTING STARTED</h1>
						<ul>
							<li>
								<span>•</span>
								The franchisor has made mistakes that you don't
								have to
							</li>
							<li>
								<span>•</span>
								The franchise will be easier to finance than an
								independent business
							</li>
							<li>
								<span>•</span>Real Estate Assistance
							</li>
							<li>
								<span>•</span>Construction Guidance
							</li>
						</ul>

						<h1>KNOWLEDGE IS POWER</h1>
						<ul>
							<li>
								<span>•</span>Training Programs
							</li>
							<li>
								<span>•</span>The Other Franchisees in the
								System
							</li>
							<li>
								<span>•</span>Track Record of Success
							</li>
							<li>
								<span>•</span>Ongoing Operational Support
							</li>
							<li>
								<span>•</span>Marketing Assistance
							</li>
							<li>
								<span>•</span>A franchise gives you a head start
							</li>
							<li>
								<span>•</span>Help is only a phone call away
							</li>
						</ul>

						<h1>A TEAM EFFORT</h1>
						<ul>
							<li>
								<span>•</span>Pooled resources translate into
								lower costs
							</li>
							<li>
								<span>•</span>You have the time to focus on your
								business
							</li>
							<li>
								<span>•</span>You can tap into instant expertise
							</li>
							<li>
								<span>•</span>
								Not a good negotiator? No problem! Most
								negotiations are done for you
							</li>
							<li>
								<span>•</span>
								You can tap into invaluable intellectual
								property and trademarks
							</li>
							<li>
								<span>•</span>You have access to important
								business data
							</li>
							<li>
								<span>•</span>
								The franchisor will stay abreast of industry
								news and keep you informed and operating
								correctly
							</li>
							<li>
								<span>•</span>Your Challenges are shared by many
							</li>
							<li>
								<span>•</span>There's power in numbers
							</li>
							<li>
								<span>•</span>
								You have a team of people working to help you
								succeed
							</li>
							<li>
								<span>•</span>Purchasing Power of a National
								Brand
							</li>
						</ul>
						<h1>FUTURE PROSPECTS</h1>
						<ul>
							<li>
								<span>•</span>You gain more control over your
								own destiny
							</li>
							<li>
								<span>•</span>You're investing in yourself
							</li>
							<li>
								<span>•</span>It can be a bridge to retirement
							</li>
							<li>
								<span>•</span>It's a good way to diversify
								assets
							</li>
							<li>
								<span>•</span>It's something that can be passed
								on.
							</li>
							<li>
								<span>•</span>Easily Own Multiple Locations
							</li>
						</ul>
					</section>
				</article>
			</div>
		</div>
	);
}
